// pixel shift: the whole picture steps one pixel at a time around a 3x3 square, one step every few minutes, so the
// plate, the band and the ticker never sit on the same pixels for long. Too small to see. Uses the CSS translate
// property, which stacks with the transform: scale() ws4kp's scaling puts on the same element.
const STEP_MINUTES = 3;
const PATH = [[0, 0], [1, 0], [1, 1], [0, 1], [-1, 1], [-1, 0], [-1, -1], [0, -1], [1, -1]];

let step = 0;
const shift = () => {
	const container = document.querySelector('#container');
	if (!container) return;
	step = (step + 1) % PATH.length;
	const [x, y] = PATH[step];
	container.style.translate = `${x}px ${y}px`;
};

setInterval(shift, STEP_MINUTES * 60000);
